import { useCallback } from 'react'

import { Edit, Preview } from '@workwave-tidal/core/icons'

import { useTexts } from '../hooks/useTexts'

import type { TrackingAppViewProps as Props } from '../types'

import { preview } from '@/components/form/preview'
import { Content } from './components/Content'

export function TrackingPageView(props: Props) {
  const { onEdit, previewUrl } = props

  const texts = useTexts()

  const onPreview = useCallback(() => {
    globalThis.open(previewUrl, '_blank')
  }, [previewUrl])

  return (
    <preview.Root
      testId="trackingPage-view"
      applyPendingFitMapOnMount={false}
      rightBorder={false}
      header={
        <preview.Header
          title={texts.headerTitle}
          subtitle={texts.headerDescription}
          testId="trackingPage-view-header"
        >
          <preview.ActionBar>
            <preview.ActionBarItem
              icon={<Edit />}
              onClick={onEdit}
              label={texts.edit}
              disableWhenReadOnly={false}
              tooltip={texts.edit}
              testId="trackingPage__edit"
              data-trackid="trackingPage__edit"
            />
            <preview.ActionBarItem
              icon={<Preview />}
              onClick={onPreview}
              label={texts.preview}
              disableWhenReadOnly={false}
              tooltip={texts.preview}
              testId="trackingPage__preview"
              data-trackid="trackingPage__preview"
            />
          </preview.ActionBar>
        </preview.Header>
      }
    >
      <Content {...props} />
    </preview.Root>
  )
}
